export default __webpack_public_path__ + "static/media/warehouse.77e7457c.png";